import { CommonModule } from '@angular/common';
import { AuthCodeFormComponent } from "../utils/auth-code-form/auth-code-form.component";
import { LoginServicesService } from '../services/login-services.service';
import { environment } from '../../environments/environment';
import { DialogModule } from 'primeng/dialog';
import { jwtDecode } from 'jwt-decode';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoaderComponent } from '../utils/loader/loader.component';
import { AppService } from '../services/app.service';
import { GeolocationService } from '@ng-web-apis/geolocation';
import { AlertModalComponent } from '../utils/alert-modal/alert-modal.component';
import { TokenService } from '../services/token.service';
import { Title } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';
import { PasswordModule } from 'primeng/password';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-login',
    imports: [
      ReactiveFormsModule, FormsModule, CommonModule,
      AuthCodeFormComponent, LoaderComponent, AlertModalComponent,
      ToastModule, InputNumberModule, PasswordModule, FloatLabelModule, ButtonModule, DialogModule
    ],
    providers: [MessageService],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  currentYear = new Date().getFullYear();
  show2FA = false;
  locationBlocked = false;
  isQA = environment.isQA;
  messageLocation = 'Estimado cliente, por razones de seguridad debe aceptar la ubicación para utilizar nuestro portal.<br />Acepte el acceso a ubicación y refresque la página<br />Si requiere más información comuníquese con atención al cliente, gracias.'
  inProcess = false;
  showButtonUpdate = false;
  latitude!: number;
  longitude!: number;
  userPhone!: string;
  tokenMovil!: string;
  tokenAppWeb!: string;
  isConfigReady = false;

  constructor(
    private loginService: LoginServicesService,
    private router: Router,
    private tokenServices: TokenService,
    private appService: AppService,
    private readonly geolocation$: GeolocationService,
    private titleService: Title,
    private messageService: MessageService
  ) {
    this.titleService.setTitle("Portal Clientes")
    this.loginForm = new FormGroup({
      clientNumber: new FormControl(null, Validators.required),
      passkeyClient: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    // Si ya tiene sesión válida, redirigir al dashboard sin limpiar storage
    if (this.loginService.isValidToken() && localStorage.getItem('data')) {
      this.router.navigate(['app/dashboard']);
      return;
    }
    localStorage.removeItem('iaTime');
    localStorage.removeItem('tokenMovil');
    localStorage.removeItem('timeOut');
    localStorage.removeItem('data');
    sessionStorage.clear();
    this.checkServerStatus();
    this.getPosition();
  }

  getPosition() {
    if (environment.isQA) {
      this.latitude = 0;
      this.longitude = 0;
      this.locationBlocked = false;
    } else {
      this.geolocation$.subscribe((position) => {
        if (position) {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.locationBlocked = false;
        } else {
          this.locationBlocked = true;
        }
      }, () => {
        this.locationBlocked = true;
      })
    }
  }

  getInactivityyTimer() {
    this.appService.checkInactivityTimeout().subscribe({
      next: (resp: any) => {
        setTimeout(() => {
          let inactivity = (resp.sessionTime - resp.timeToLogOut) * 60;
          localStorage.setItem('iaTime', inactivity.toString());
          localStorage.setItem('timeOut', (resp.timeToLogOut * 60).toString());
          this.isConfigReady = true;
        }, 1000);
      }
    });
  }

  get clientNumber() { return this.loginForm.get('clientNumber'); }
  get passkeyClient() { return this.loginForm.get('passkeyClient'); }

  checkServerStatus() {
    this.loginService.checkStatus().subscribe({
      next: () => this.getInactivityyTimer(),
      error: () => {}
    })
  }

  goto(route: string, isRecovery: boolean) {
    if (isRecovery) {
      this.router.navigate([route]);
    } else {
      this.router.navigate([route, { isExpired: true, client: this.clientNumber!.value }]);
    }
  }

  validateOTP(data: any) {
    this.show2FA = false;
    if (!data.error && data != false) {
      localStorage.setItem('data', JSON.stringify(jwtDecode(data.token!)));
      this.saveDataUser(data.token, data.tokenMovil);
    }
  }

  submit() {
    this.showButtonUpdate = false;
    if (!this.loginForm.valid) return;

    this.inProcess = true;
    this.loginService.login(
      this.clientNumber!.value.toString(),
      this.passkeyClient!.value
    ).subscribe({
      next: (response: any) => {
        this.inProcess = false;
        if (response.is2FA) {
          if (response.message) {
            this.showError(response.message);
          } else {
            this.show2FA = true;
          }
          return;
        }
        if (response.error) {
          this.showError(response.message);
          if (response.message?.includes('expiró.')) this.showButtonUpdate = true;
          return;
        }
        localStorage.setItem('data', JSON.stringify(jwtDecode(response.token!)));
        this.showSuccess('Acceso validado, redirigiendo...');
        this.saveDataUser(response.token, response.tokenMovil);
      },
      error: (err: any) => {
        this.inProcess = false;
        const msg = err.status === 429
          ? 'Has superado el número máximo de intentos. Inténtalo en 15 minutos.'
          : err.error?.error || 'Error al iniciar sesión';
        this.showError(msg);
        if (msg.includes('expiró.')) this.showButtonUpdate = true;
      }
    });
  }

  saveDataUser(tokenApi: string, tokenMovil: string) {
    localStorage.setItem('tokenMovil', tokenMovil);
    this.tokenServices.setToken(tokenApi);
    var data = JSON.parse(localStorage.getItem('data')!);
    this.loginService.saveLoginLocation(
      this.clientNumber!.value.toString(),
      data.User_id == 0 ? 'Administrador de la cuenta' : data.Name,
      this.latitude, this.longitude
    ).subscribe({
      next: () => this.router.navigate(['app/dashboard']),
      error: () => this.router.navigate(['app/dashboard'])
    });
  }

  resendLoginCodeMovil() {
    let decoded = JSON.parse(localStorage.getItem('data')!);
    this.loginService.loginMovil(
      this.clientNumber!.value.toString(),
      this.passkeyClient!.value, true, decoded.Version!
    ).subscribe({
      error: () => this.showError('Hubo un problema al contactar al servidor, reintente de nuevo')
    });
  }

  private showError(msg: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: msg, life: 5000 });
  }

  private showSuccess(msg: string) {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: msg, life: 3000 });
  }
}
